import { QuoteIneligibilitiesResponse } from '@services/ineligibility/ineligibility.types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useQuoteIneligibility = (quoteId: string) => {
  const client = useClient();
  const queryUrl = `quote/${quoteId}/quote-ineligibility`;
  const result = useQuery<QuoteIneligibilitiesResponse, Error>({
    queryKey: ['quoteIneligibilities', { quoteId }],
    queryFn: async () => {
      const response = await client.get(queryUrl).json<QuoteIneligibilitiesResponse>();
      return response;
    },
    enabled: !!quoteId,
  });
  return { ...result };
};
